import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, NgZone } from '@angular/core';

import { AsperaService } from '../aspera/aspera.service';
import { Transfer } from './transfer.model';
import { TransferFile } from './transfer-file.model';
import { TransfersService } from './transfers.service';

@Component({
  selector: 'app-active-transfer',
  templateUrl: './active-transfer.component.html',
  styleUrls: ['./active-transfer.component.scss']
})
export class ActiveTransferComponent implements OnInit, OnDestroy {
  @Output() transferEnded = new EventEmitter<string>();
  @Input() activeFiles: TransferFile[];
  @Input() direction: string; // 'upload' or 'download'

  listener: (eventType: string, data: any) => void;
  loading = true;
  private filesListInFlight = false;

  constructor(
    private ngZone: NgZone,
    private asperaService: AsperaService,
    private transfersService: TransfersService) { }

  ngOnInit() {
    this.listener = (eventType: string, data: any) => this.onTransfersUpdate(data);
    this.asperaService.addTransferListener(this.listener);
  }

  ngOnDestroy() {
    this.asperaService.removeTransferListener(this.listener);
  }

  onTransfersUpdate(data: any) {
    for (const transferInfo of data.transfers) {
      const cookie = transferInfo.transfer_spec.cookie;
      if (cookie) {
        this.onTransferUpdate(transferInfo);
        return;
      }
    }
  }

  onTransferUpdate(transferInfo: any) {
    this.ngZone.run(() => this.loading = false);
    const status = transferInfo.status;

    switch (status) {
    case 'running': {
      if (this.asperaService.supportsPerFileProgress()) {
        this.updatePerFileProgress(transferInfo.uuid);
      } else {
        const percentage = transferInfo.percentage != null
          ? transferInfo.percentage * 100.0
          : (transferInfo.bytes_written / transferInfo.bytes_expected) * 100.0;
        for (const file of this.activeFiles) {
          this.ngZone.run(() => file.progress = percentage);
        }
      }
      break;
    }
    case 'completed':
      for (const file of this.activeFiles) {
        this.ngZone.run(() => file.progress = 100);
      }
      setTimeout(() => this.transferEnded.emit(status), 1000);
      break;
    case 'failed':
    case 'canceled':
    case 'cancelled':
      this.transferEnded.emit(status);
      break;
    }
  }

  updatePerFileProgress(transferId: string) {
    // Skip if slow check is in progress
    if (this.filesListInFlight) { return; }
    this.filesListInFlight = true;
    this.asperaService.getTransferFiles(transferId)
      .then((response: any) => {
        this.filesListInFlight = false;
        const entries = response.entries || [];
        if (response.total_count != null && response.limit != null
            && response.total_count > response.limit) {
          console.warn('Transfer has ' + response.total_count + ' files; per-file '
            + 'progress is limited to the first ' + response.limit + '.');
        }
        const statByName = new Map<string, any>();
        for (const entry of entries) {
          statByName.set(this.asperaService.fileNameFromPath(entry.file), entry);
        }
        for (const file of this.activeFiles) {
          const entry = statByName.get(file.name);
          if (entry == null) { continue; }
          let progress = 0;
          if (entry.status === 'finished') {
            progress = 100;
          } else if (entry.bytes_expected > 0) {
            progress = (entry.bytes_written / entry.bytes_expected) * 100.0;
          }
          this.ngZone.run(() => file.progress = progress);
        }
      })
      .catch((error: any) => {
        this.filesListInFlight = false;
        console.log('getFilesList error: ', error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/transfers/active-transfer.component.ts